import React, { Fragment } from 'react';
import { Modal, Flex, Spin, Progress } from 'antd';
import { useTranslation } from 'react-i18next';

interface ExportProgressModalProps {
  title?: string;
  processLabel?: string;
  visible: boolean;
  progress: number;
}

const ExportProgressModal: React.FC<ExportProgressModalProps> = ({ title, processLabel, visible, progress }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title || t('common.exportAllExcel') + "..."}
      closable={false}
      footer={null}
      maskClosable={false}
      open={visible}
      centered
      width={1000}
      zIndex={99999}
    >
      <Flex style={{ marginTop: 120, marginBottom: 100 }} justify="center">
        <Spin spinning={visible} size="large" />
      </Flex>
      {
        !!progress && (
          <Fragment>
            <Progress percent={progress} />
            <span>{`${processLabel || t('common.exporting')}：${progress}%`}</span>
          </Fragment>
        )
      }
    </Modal>
  );
};

export default ExportProgressModal;
